import { DownloadNotificationItem } from '../types';

export interface DownloadNotificationState {
  downloads: DownloadNotificationItem[];
}

export const initialState: DownloadNotificationState = {
  downloads: [],
};
